import { useState, useEffect } from "react";

const CurrentBranch = ({ branch }) => {
  const [name, setName] = useState("");

  useEffect(() => {
    if (branch) {
      if (window.innerWidth <= 768) {
        setName("...");
      } else {
        setName(branch);
      }
    }
  }, [branch]);
  return <span className="fw-medium">{name ?? ""}</span>;
};

export default CurrentBranch;
